import { useEffect, useState } from "react";
import { CheckCircle2, Loader2, XCircle, Zap } from "lucide-react";
import { Button } from "@/components/ui/button";
import { usd } from "@/components/ai/useAiEdits";
import { errMsg, useApi } from "@/lib/api";

// Minimal real call (a few tokens) to check a key: the cost is shown on the button and sent as confirmation.
export default function KeyTest({ provider, source, label, disabled }) {
  const api = useApi();
  const [est, setEst] = useState(null);
  const [state, setState] = useState(null);
  useEffect(() => {
    api.post(`/settings/keys/${provider}/test/estimate`, { source }).then(({ data }) => setEst(data.estimate)).catch(() => setEst(null));
  }, [api, provider, source]);
  const run = async () => {
    setState("loading");
    try { const { data } = await api.post(`/settings/keys/${provider}/test`, { source, confirm_usd: est.usd }); setState(data); }
    catch (e) { setState({ ok: false, error: errMsg(e) }); }
  };
  const id = `key-test-${provider}-${source}`;
  return (
    <div className="flex flex-wrap items-center gap-2">
      <Button variant="outline" size="sm" onClick={run} disabled={disabled || !est || !!est.blocked || state === "loading"} title={est ? `${est.model} · ${est.note}` : ""} data-testid={id}>
        {state === "loading" ? <Loader2 size={13} className="mr-1.5 animate-spin" /> : <Zap size={13} className="mr-1.5" />}{label}{est ? ` · ${usd(est.usd)}` : ""}
      </Button>
      {state && state !== "loading" && (state.ok
        ? <span className="text-xs text-emerald-700 inline-flex items-center gap-1" data-testid={`${id}-ok`}><CheckCircle2 size={14} />Connesso · {state.model} · {state.latency_ms} ms</span>
        : <span className="text-xs text-red-600 inline-flex items-start gap-1 break-words" data-testid={`${id}-error`}><XCircle size={14} className="shrink-0" />{state.error}</span>)}
    </div>
  );
}
